import { FileFolderPath, Id, Resource } from '@nextforce/api'

export interface ChatGroupMediaScreenParams {
  conversationId: Id
}

export interface ChatGroupFoldersScreenParams {
  conversationId: Id
  path?: FileFolderPath[]
}

export interface SharedFileFoldersScreenParams {
  conversationId: Id
  path?: FileFolderPath[]
}

export interface RecentAcknowledgementsScreenParams {
  conversationId: Id
}

export interface EditFileFolderScreenParams {
  id: Id
  type: Resource['type']
}

export interface FileViewerScreenParams {
  fileId: Id
  versionNumber?: number
}

export interface ChatFileViewerScreenParams {
  fileId: Id
  conversationId: Id
  currentFolderId?: Id
}

export interface FilefolderSearchScreenParams {
  conversationId: Id
}

export interface ShareResourceRecipientsScreenParams {
  resourceId: Id
  resourceType: Resource['type']
  requestAcknowledgement?: boolean
  conversationId?: Id
}

export interface ShareResourceDetailsScreenParams {
  requestAcknowledgement?: boolean
  conversationId?: Id
}

export interface AcknowledgeResourceScreenParams {
  resourceId: Id
  resourceType: Resource['type']
}

export interface FileAcknowledgementsScreenParams {
  fileId: Id
}

export const FileFolderSortOptions = [
  'nameAsc',
  'dateAsc',
  'dateDesc',
  'sizeDesc',
] as const

export type FileFolderSortOption = (typeof FileFolderSortOptions)[number]

export const FileFolderViewModes = ['list', 'grid', 'timeline'] as const

export type FileFolderViewMode = (typeof FileFolderViewModes)[number]
